import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { HomeOutlined, PersonOutline, LockOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { QuickLinksProvider } from "../../context/QuickLinksContext";
import Layout from "../../layout/Layout";
import SecurityTab from "./SecurityTab";
import MyProfile from "../Content/MyProfile/MyProfile";
import BasicProfile from "./BasicProfile";
import ClientProfile from "./ClientProfile";
import {
  PageWrapper,
  BreadcrumbRow,
  BreadcrumbText,
  PageTitle,
  PageSubtitle,
  SettingsLayout,
  SettingsNav,
  NavItem,
  SettingsMain,
} from "./Settings.styles";

const Settings = () => {
  const navigate = useNavigate();
  const { iphcPractitioner, userData } = useSelector((state) => state.user);

  // Profile form depends on the account type:
  //  - practitioner → full practitioner profile (with admin review)
  //  - client (patient) → DB-backed patient profile (non-clinical fields)
  //  - everyone else (admin) → basic account profile (name + avatar)
  const isPractitioner = !!iphcPractitioner;
  const isClient = userData?.role === "patient";

  const NAV_ITEMS = [
    { key: "profile", label: "Profile", Icon: PersonOutline },
    { key: "password", label: "Password", Icon: LockOutlined },
  ];

  const [section, setSection] = useState("profile");

  return (
    <QuickLinksProvider>
      <Layout>
        <PageWrapper>
          <BreadcrumbRow>
            <IconButton size="small" onClick={() => navigate("/home")} sx={{ color: "#33261D" }}>
              <HomeOutlined fontSize="small" />
            </IconButton>
            <BreadcrumbText>/ Settings</BreadcrumbText>
          </BreadcrumbRow>

          <PageTitle>Settings</PageTitle>
          <PageSubtitle>Manage your account and preferences</PageSubtitle>

          <SettingsLayout>
            <SettingsNav>
              {NAV_ITEMS.map(({ key, label, Icon }) => (
                <NavItem key={key} $active={section === key} onClick={() => setSection(key)}>
                  <Icon />
                  {label}
                </NavItem>
              ))}
            </SettingsNav>

            <SettingsMain>
              {section === "profile" ? (
                isPractitioner ? (
                  <MyProfile />
                ) : isClient ? (
                  <ClientProfile />
                ) : (
                  <BasicProfile />
                )
              ) : (
                <SecurityTab />
              )}
            </SettingsMain>
          </SettingsLayout>
        </PageWrapper>
      </Layout>
    </QuickLinksProvider>
  );
};

export default Settings;
